import React, { useState, useEffect } from "react";
import Translations from "../../services/translation.service";
import User from "../../services/user.service";

import doneIcon from "../../assets/img/Delivery-Speed_2.svg";
import AppleIcon from "../../assets/img/apple.png";
import GoogleIcon from "../../assets/img/google.png";
import HuaweiIcon from "../../assets/img/huawei.png";
import Settings from "../../services/settings.service";
import SIM from "../../services/sim.service";
import GTMService from "../../services/gtm.service";
import StorefrontTitle from "../shared/storefront-title.component";
import FirebaseAnalytics from "../../services/analytics.service";
import CONSTANTS from "../../services/constants.service";
import Activation from "../../services/activation.service";
import Helpers from "../../helpers/shared.helper";
import Storage from "../../services/storage.service";

const subscriptions = [];
export default function WaitingForDriver(props) {
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [showConfirmation, setShowConfirmation] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []);

  useEffect(() => {
    GTMService.sim_on_the_way();
  });

  const simDelivered = () => {
    localStorage.setItem("SimProcessCompleted", true);

    SIM.getDeliveryStatus().then((response) => {
      props.history.push("/scan-qr-code");
    });

    GTMService.event(
      "got_sim_btn_click",
      "Waiting For Driver",
      "sim_delivered",
      "Sim Delivered"
    );

    User.fetchFlowStatus();
  };

  const cancelDelivery = () => {
    let delivery_booking_id = Storage.get("delivery_booking_id", true);
    Helpers.log("delivery_booking_id==>", delivery_booking_id);
    SIM.cancelDelivery(delivery_booking_id)
      .then((response) => {
        Activation.getModules()
          .then((res) => {
            Storage.clear("delivery_booking_id");
            Storage.clear("selected_module");
            Storage.clear("sim_activation_type");
            Storage.clear("module");
            User.fetchFlowStatus();
            setShowConfirmation(false);
          })
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  let showConfirmationModal = null;
  if (showConfirmation) {
    showConfirmationModal = (
      <div className="confirmation-modal">
        <div className="confirmation-modal-content">
          <div className="confirmation-modal-title">
            {Translations.keys["3_9_A_cancel_delivery"]}
          </div>
          <div className="confirmation-modal-message">
            {Translations.keys["3_9_A_cancel_delivery_confirmation"]}
          </div>
          <div className="modal-btns">
            <button className="continue-button red" onClick={cancelDelivery}>
              {Translations.keys["scr_4.4_E_MNP_cancel_alert_btn_yes"]}
            </button>
            <button
              className="continue-button light-red"
              onClick={() => {
                setShowConfirmation(false);
              }}
            >
              {Translations.keys["scr_4.4_E_MNP_cancel_alert_btn_no"]}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-ob-single">
      <div className="waiting_for_delivery">
        <img src={doneIcon} className="doneIcon" alt="done-icon" />
        {showConfirmationModal}
        <StorefrontTitle
          title={translationKeys["ob_waiting_for_driver_sim_on_the_way"]}
          desc={translationKeys["ob_waiting_for_driver_text1"]}
        />
        <p className="textClass">
          {translationKeys["ob_waiting_for_driver_text2"]}
        </p>

        <button className="continue-button red" onClick={() => {
          FirebaseAnalytics.button_clicked(CONSTANTS.DELIVERY_SCREEN, "ob_waiting_for_driver_button");
          simDelivered()
        }}>
          {translationKeys["ob_waiting_for_driver_button"]}
        </button>
        <button
          className="continue-button light-red"
          onClick={() => {
            FirebaseAnalytics.button_clicked(CONSTANTS.DELIVERY_SCREEN, "ob_waiting_for_driver_cancel_button");

            setShowConfirmation(true);
          }}
        >
          {translationKeys["ob_waiting_for_driver_cancel_button"]}
        </button>

        <div className="download-app-section">
          <span>
            {translationKeys["ob_create_acc_why_not_to_dowload_the_app"]}
          </span>
          <ul className="modal-app-links">
            <li>
              <a href={Settings.get("ob_google_play")}>
                <img src={GoogleIcon} alt="Google" />
              </a>
            </li>
            <li>
              <a href={Settings.get("ob_app_store")}>
                <img src={AppleIcon} alt="Apple" />
              </a>
            </li>
            <li>
              <a href={Settings.get("ob_app_gallery")}>
                <img src={HuaweiIcon} alt="Huawei" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
